export default {"src":"/_next/static/media/dollar_coin.d8bf29f2.svg","height":32,"width":32,"blurWidth":0,"blurHeight":0};